import React from 'react';
import {BaseMixin, ElementaryMixin} from './../common/common.js';

import InputWrapper from './internal/input-wrapper.js';
import TextInput from './internal/text-input.js';

import TextInputMixin from './mixins/text-input-mixin.js'

import ItemList from './internal/item-list.js';
import Backdrop from './../bricks/backdrop.js';

import './text-glyphicon.less';

export const TextGlyphicon = React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin,
    TextInputMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Forms.TextGlyphicon',
    classNames: {
      main: 'uu5-forms-text-glyphicon',
      clickable: 'uu5-forms-text-glyphicon-clickable',
      left: 'uu5-forms-text-glyphicon-left',
      right: 'uu5-forms-text-glyphicon-right',
    },
    errors: {
      validateError: 'Validated result is not object.'
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    value: React.PropTypes.string,
    password: React.PropTypes.bool,
    glyphicon: React.PropTypes.string,
    glyphiconPosition: React.PropTypes.oneOf(['left', 'right']),
    onClick: React.PropTypes.func
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  getDefaultProps: function () {
    return {
      value: '',
      password: false,
      glyphicon: null,
      glyphiconPosition: 'right',
      onClick: null
    };
  },
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  componentWillMount(){
    if (this.props.onValidate && typeof this.props.onValidate === 'function') {
      this._validateOnChange({value: this.state.value, event: null, component: this})
    }

    return this;
  },

  componentWillReceiveProps(nextProps) {
    if (this.props.controlled) {
      if(nextProps.required && (nextProps.value === '' || nextProps.value === null)) {
        this.setError(nextProps.requiredMessage);
      } else {
        this.setFeedback(nextProps.feedback, nextProps.message, nextProps.value)
      }
    }
    return this;
  },
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  // TODO: tohle je ještě otázka - je potřeba nastavit hodnotu z jiné komponenty (musí být validace) a z onChange (neměla by být validace)
  setValue_(value, setStateCallback){
    if (this._checkRequired({ value: value })) {
      if (typeof this.props.onValidate === 'function') {
        this._validateOnChange({ value: value, event: null, component: this })
      } else {
        this.props.required ? this.setSuccess(null, value, setStateCallback) : this.setInitial(null, value, setStateCallback);
      }
    }

    return this;
  },
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers

  _validateOnChange(opt){
    let result = typeof this.props.onValidate === 'function' ? this.props.onValidate(opt) : null;
    if (result) {
      if (typeof result === 'object') {
        if (result.feedback) {
          this.setFeedback(result.feedback, result.message, result.value);
        } else {
          this.setState({ value: opt.value });
        }
      } else {
        this.showError('validateError', null, { context: { event: e, func: this.props.onValidate, result: result } });
      }
    }
    return this;
  },

  _getMainAttrs(){
    let result = this._getInputAttrs();
    result.className += ' ' + (this.props.glyphiconPosition === 'left' ? this.getClassName().left : this.getClassName().right);
    return result;
  },

  _glyphiconOnClick(){
    let result;
    if (typeof this.props.onClick === 'function') {
      result = this.props.onClick({value: this.state.value, component: this})
    }
    return result;

  },

  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function () {
    let inputId = this.getId() + '-input';

    return (
      <div {...this._getMainAttrs()}>
        {this.getLabel(inputId)}
        {this.getInputWrapper([
          <TextInput
            id={inputId}
            name={this.props.name || inputId}
            value={this.state.value}
            placeholder={this.props.placeholder}
            type={this.props.password ? 'password' : this.props.type || 'text'}
            onChange={this.onChange}
            onBlur={this.onBlur}
            onFocus={this.onFocus}
            onKeyDown={this.onKeyDown}
            mainAttrs={this.props.inputAttrs}
            disabled={this.isDisabled() || this.isLoading()}
            readonly={this.isReadOnly()}
            glyphicon={this.props.glyphicon}
            glyphiconOnClick={this._glyphiconOnClick}
            loading={this.isLoading()}
            textGlyphicon={true}
          />,

          this.state.autocompleteItems && <ItemList {...this._getItemListProps()}>
            {this._getChildren()}
          </ItemList>,
          this.state.autocompleteItems && <Backdrop {...this._getBackdropProps()} />])}
      </div>
    );
  }
  //@@viewOn:render
});

export default TextGlyphicon;



// WEBPACK FOOTER //
// ./forms/text-glyphicon.js